const ROLLUP_MODAL_LOAD_TYPE = "ROLLUP_MODAL_LOAD";

export const reducer = (state = {}, action) => {
  switch (action.type) {
    case ROLLUP_MODAL_LOAD_TYPE:
      return {
        data: action.data
      };
    default:
      return state;
  }
};

export const LoadRollupModal = data => ({
  type: ROLLUP_MODAL_LOAD_TYPE,
  data
});
